module.exports = __webpack_public_path__ + "img/23.5.COD.b1b6e227.png";